import { React, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { styled, alpha } from "@mui/material/styles";
import { Button, Menu, MenuItem } from "@mui/material";

import { Common, CommonPages, EditProfileConstants } from "../../helper";
import { SessionStorage } from "../../util";
import { clearStore } from "../..";

import "../../assets/stlyes/Actions.css";

import ProfileIcon from "../../assets/images/ProfileIcon.png";

const StyledMenu = styled((props) => (
  <Menu elevation={0} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right", }}{...props} />))(({ theme }) => ({
  "& .MuiPaper-root": {
    marginTop: theme.spacing(1),
    color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
    boxShadow: "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": { padding: "0" },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": { fontSize: 18, color: theme.palette.text.secondary, marginRight: theme.spacing(1.5), },
      "&:active": { backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity) },
    },
  },
}));

const Action = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl)
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleClick = (e) => { setAnchorEl(e.currentTarget) };
  const handleClose = () => { setAnchorEl(null) };
  const handleCloseLogoutModal = () => setShowLogoutModal(false);
  const handleShowLogoutModal = () => setShowLogoutModal(true);

  const logOut = async () => {
    clearStore();
    SessionStorage.clearAll();
    navigate(CommonPages.login)
    window.location.reload()
  }

  return (
    <div className="header-action-dropdown">
      <Button id="demo-customized-button" aria-controls={open ? "demo-customized-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined} variant="contained" disableElevation onClick={handleClick} style={{ background: "none" }}>
        <img src={ProfileIcon} alt="Profile" className="header-icons" />
      </Button>
      <StyledMenu id="demo-customized-menu" MenuListProps={{ "aria-labelledby": "demo-customized-button", }} anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem disableRipple style={{ background: "#084059" }}>
          <button onClick={() => { window.location = "/Update-Profile"; }} style={{ width: "140px", display: "flex", padding: "0px 8px", background: "#084059", color: "#FFF" }}>
            {Common.UpdateProfile}
          </button>
        </MenuItem>
        <MenuItem disableRipple style={{ background: "#084059" }}>
          <button onClick={() => { window.location = "/UpdatePassword"; }} style={{ background: "#084059", color: "#FFF" }}>{EditProfileConstants.ChangePassword}</button>
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple style={{ background: "#084059" }}>
          <button onClick={handleShowLogoutModal} style={{ width: "140px", display: "flex", padding: "0px 8px", background: "#084059", color: "#FFF" }}>{Common.LogOut}</button>
        </MenuItem>
      </StyledMenu>
      <Modal show={showLogoutModal} onHide={handleCloseLogoutModal} className="comment-modal_">
        <Modal.Header closeButton className="comment-modal-header">
          <Modal.Title>&nbsp;&nbsp;{EditProfileConstants.LogoutConfirmation}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="comment-modal-body">&nbsp;&nbsp;{EditProfileConstants.AreYouSureYouWantToLogout}</Modal.Body>
        <Modal.Footer className="comment-modal-footer_">
          <button onClick={handleCloseLogoutModal} className="cancelButton-for-logout-modal">{Common.Cancel}</button>
          <button onClick={logOut} className="submit-button-for-logout-modal">{EditProfileConstants.YesLogout}</button>
        </Modal.Footer>
      </Modal>
    </div >
  );
}

export { Action };
